import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { AppSettingsService, FeatureService } from '../services';

/*
 * Embedd feature guard overrides the base feature guard logic and ignores feature flags
 * so it should be used exclusively and not with featureGuard specifically for routes that
 * can be accessed when within the native app regardless of feature settings
 */

@Injectable({
	providedIn: 'root',
})
export class EmbeddedGuard {
	constructor(protected featureService: FeatureService, protected appSettingsService: AppSettingsService) {}

	canLoad(route: Route): Observable<boolean> | Promise<boolean> | boolean {
		return this.validForRoute(route);
	}

	canActivate(next: ActivatedRouteSnapshot): Observable<boolean> | Promise<boolean> | boolean {
		return this.validForRoute(next);
	}

	validForRoute(route: ActivatedRouteSnapshot | Route): Observable<boolean> | Promise<boolean> | boolean {
		if (!this.featureService.state.enabledFeatures) {
			return false;
		}

		if (this.appSettingsService.settings.isEmbeddedInApp) {
			return true;
		}

		const routeFeature = route.data?.feature || null;

		return this.featureService.state$.pipe(
			filter((s) => !!s.updatedFromServer),
			map((s) => s.enabledFeatures.includes(routeFeature)),
			take(1)
		);
	}
}
